import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';

@Component({
  selector: 'app-select-input',
  templateUrl: './select-input.component.html',
})
export class SelectInputComponent {
  @Input() control!: AbstractControl;
  @Input() label = '';
  @Input() required = false;
  @Input() optional = false;
  @Input() submitted = false;
  @Input() errorMessages: { [key: string]: string } = {};
  @Input() serverError: string | null | undefined = '';
  @Input() items: any[] = [];
  @Input() bindLabel = 'FieldText';
  @Input() bindValue = '';
  @Input() multiple = false;
  @Input() searchable = true;
  @Input() closeOnSelect = true;
  @Input() id = '';
  @Input() placeholder = '';
  @Input() selectClass = '';
  @Input() readonly = false;

  @Output() change = new EventEmitter<any>();
  @Output() focus = new EventEmitter<any>();
  @Output() focusout = new EventEmitter<any>();
  @Output() keypress = new EventEmitter<KeyboardEvent>();

  get formControl(): FormControl {
    return this.control as FormControl;
  }

  get isInvalid(): boolean {
    return !!(this.submitted && this.control && this.control.invalid);
  }
}
